/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { ClosedEnum } from "../../types/enums.js";

/**
 * Dimension to filter on
 */
export const Dimension = {
  DepartmentName: "department_name",
  JobTitle: "job_title",
  EmployeeType: "employee_type",
  DivisionName: "division_name",
  CostCenterName: "cost_center_name",
  Email: "email",
  Hostname: "hostname",
  Model: "model",
  HookSource: "hook_source",
  AccountType: "account_type",
  Provider: "provider",
  BillingMode: "billing_mode",
  QuerySource: "query_source",
  SkillName: "skill_name",
  SkillVersion: "skill_version",
  AgentName: "agent_name",
  McpServerName: "mcp_server_name",
  McpToolName: "mcp_tool_name",
  Role: "role",
  Group: "group",
  ProjectId: "project_id",
} as const;
/**
 * Dimension to filter on
 */
export type Dimension = ClosedEnum<typeof Dimension>;

/**
 * A single filter predicate on an allowlisted dimension
 */
export type QueryFilter = {
  /**
   * Dimension to filter on
   */
  dimension: Dimension;
  /**
   * Match if the dimension equals any of these values (IN semantics; for multi-valued dimensions like role/group, matches if any element is present).
   */
  values: Array<string>;
};

/** @internal */
export const Dimension$outboundSchema: z.ZodMiniEnum<typeof Dimension> = z.enum(
  Dimension,
);

/** @internal */
export type QueryFilter$Outbound = {
  dimension: string;
  values: Array<string>;
};

/** @internal */
export const QueryFilter$outboundSchema: z.ZodMiniType<
  QueryFilter$Outbound,
  QueryFilter
> = z.object({
  dimension: Dimension$outboundSchema,
  values: z.array(z.string()),
});

export function queryFilterToJSON(queryFilter: QueryFilter): string {
  return JSON.stringify(QueryFilter$outboundSchema.parse(queryFilter));
}
